import HttpClient from "../httpClient";
import { ParameterUnitItem, ParameterUnitFilter, CreateParameterUnit, UpdateParameterUnit } from "../../models/types/parameterUnit";
import { DefaultResponse, DefaultResponseContent, DefaultFilterRequest } from "../../models/types/common";

class ParameterUnitService {
    private service = HttpClient;

    async getAll(requestData: DefaultFilterRequest<ParameterUnitFilter>): Promise<DefaultResponseContent<ParameterUnitItem[]>> {
        const response = await this.service.get<DefaultResponseContent<ParameterUnitItem[]>>("/admin/Unit/GetAll", requestData);
        return response;
    }

    async getLookup(): Promise<DefaultResponse<any[]>> {
        const response = await this.service.get<DefaultResponse<any[]>>("/admin/Unit/GetLookup");
        return response;
    }

    async getParameterUnitById(id: string): Promise<DefaultResponse<ParameterUnitItem>> {
        const response = await this.service.get<DefaultResponse<ParameterUnitItem>>(`/admin/Unit/GetDetail/${id}`);
        return response;
    }

    async createParameterUnit(requestData: CreateParameterUnit): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Unit/Create`, requestData);
        return response;
    }

    async updateParameterUnit(requestData: UpdateParameterUnit): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Unit/Update`, requestData);
        return response;
    }

    async deleteParameterUnit(id: number | string): Promise<DefaultResponse<any>> {
        const response = await this.service.delete<DefaultResponse<any>>(`/admin/Unit/Delete/${id}`);
        return response;
    }

}

const parameterUnitSvc = new ParameterUnitService();
export default parameterUnitSvc;
